import axios from "axios";

const APP_ENV = process.env.REACT_APP_ENV || "production";

let IMAGE_BASE_URL = "";
let BASE_URL = "";
let server = "";

switch (APP_ENV) {
  case "dev":
    IMAGE_BASE_URL = "http://192.168.1.9:2001/public";
    BASE_URL = "http://192.168.1.9:2001/api/admin";
    server = "http://192.168.1.9:2001";
    break;

  case "production":
    IMAGE_BASE_URL = "https://api.prompttradefairs.com/public";
    BASE_URL = "https://api.prompttradefairs.com/api/admin";
    server = "https://api.prompttradefairs.com";
    break;

  case "local":
  default:
    IMAGE_BASE_URL = "http://192.168.88.26:2001/public";
    BASE_URL = "http://192.168.88.26:2001/api/admin";
    server = "http://192.168.88.26:2001";
    break;
}

const apiClient = axios.create({
  baseURL: BASE_URL,
});

apiClient.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("userToken");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (
      error.response?.status === 401 &&
      !error.config.url.includes("login") &&
      !error.config.url.includes("verify-move") &&
      !window.location.pathname.includes("sign-in")
    ) {
      localStorage.removeItem("userToken");
      window.location.href = "/sign-in";
    }
    return Promise.reject(error);
  }
);

const getImageUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${IMAGE_BASE_URL}/${path.replace(/^\/+/, "")}`;
};

export { IMAGE_BASE_URL, BASE_URL, server, apiClient, apiClient as api, apiClient as clientApi, BASE_URL as API_URL, BASE_URL as CLIENT_API_URL, getImageUrl };

export default apiClient;